import { render, staticRenderFns } from "./PartnersPayments.vue?vue&type=template&id=299da2e7"
import script from "./PartnersPayments.vue?vue&type=script&lang=js"
export * from "./PartnersPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports